import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginDataService } from '../../modules/login/services/login-data.service';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private loginDataService: LoginDataService) {}
  token: any;
  isLoggedIn: any;
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add auth header with Auth if user is logged in and request is to the api url

    const startTime = Date.now();

    this.token = this.loginDataService.getSharedData('token');
    this.isLoggedIn = this.loginDataService.getSharedData('isLoggedIn');

    const isApiUrl = request.url.includes(`${environment.apiUrl}`);
    if (isApiUrl && this.isLoggedIn) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ` + this.token, // ${currentUser.token}`,
          Accept: 'application/json',
        },
      });
    }

    return next.handle(request).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          const endTime = Date.now();
          event = event.clone({
            headers: event.headers.set('endTime', endTime.toString()),
          });
          event = event.clone({
            headers: event.headers.set('startTime', startTime.toString()),
          });
        }
        return event;
      })
    );
  }
}
